import { Component, Input } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageCode } from '../../models/language-code';
import { langCodeToIntlFEData } from '../../models/languages-fe-model';
import { LocalizationService } from '../../services/localization.service';
import { FlagComponent } from '../flag/flag.component';
import { TooltipCustomComponent } from '../tooltip-custom/tooltip-custom.component';

@Component({
    selector: 'apcam-mat-tab-label-with-flag',
    imports: [
        FlagComponent,
        MatBadgeModule,
        TooltipCustomComponent,
        TranslatePipe,
    ],
    templateUrl: './mat-tab-label-with-flag.component.html',
    styleUrl: './mat-tab-label-with-flag.component.scss',
})
export class MatTabLabelWithFlagComponent {
    /**
     * Specifies whether an action is required on the given tab.
     */
    @Input()
    actionRequired: boolean = false;

    /**
     * Color of the badge. Can be one of the following: 'primary' | 'accent' | 'warn'.
     */
    @Input()
    badgeColor: 'primary' | 'accent' | 'warn' = 'accent';

    /**
     * The language code for the flag.
     */
    @Input()
    language: LanguageCode = this.localizationService.defaultLanguage;

    constructor(private readonly localizationService: LocalizationService) {}

    langCodeToIntlFEData = langCodeToIntlFEData;
}
